"use strict";

import { AddonError, Vendor as MggpVendor } from 'mggp-player';

const MggpPluginBuffering = require('mggp-plugin-buffering');

export default function MggpVendorHtml5(pPlayer, pConfig) {
  MggpVendor.apply(this, arguments);
  var self = this;
  var pluginBuffering;

  if (self.player.get('player:usePluginBuffering')) {
    pluginBuffering = new MggpPluginBuffering(pPlayer, pConfig);
  }

  var playing = null;
  var _src = null;
  var _videoInfo = null;
  var _video = null;
  var _startPosition = 0;
  var _started = false;
  var _paused = false;
  var _beforeCompleteFired = false;
  var _needToDisableSubtitles = false;
  var _isBuffering = false;
  var _isSafari;
  var _isAndroid;
  var _isIos;
  var _safariAfterSeekedTimeoutId = null;
  var _safariStalledTimeoutId = null;
  var _safariPlayRetryCount = 0;
  var _safariStalledPosition = null;
  var _seekState = null;

  this.dispose = function () {
    toggleEvents(false);

    _src = null;
    _videoInfo = null;
    _needToDisableSubtitles = false;
    _safariPlayRetryCount = 0;
    _isBuffering = false;

    if (!self.player.config.singleVideoInstance) {
      _video = null;
      self.player = null;
      self.namespase = null;
      self.config = null;
    }

    if (pluginBuffering) {
      pluginBuffering.dispose();
    }
  };

  this.load = function (pSrc, pVideoInfo, pOptions) {
    var browserName;
    var deviceName;
    try {
      browserName = self.player.config.device.browser.name.toLowerCase();
      deviceName = self.player.config.device.os.name.toLowerCase();
    } catch (error) {}
    // browsers
    _isSafari = browserName === 'safari';
    // os
    _isAndroid = deviceName === 'android';
    _isIos = deviceName === 'ios';

    if (pOptions) {
      if (!self.checkOptions(pOptions)) {
        return;
      }
    } else {
      pOptions = {};
    }
    setState(5);
    _needToDisableSubtitles = true;

    pSrc = removeM3U8FromBlobUrl(pSrc);
    if (pVideoInfo) {
      pVideoInfo.src = removeM3U8FromBlobUrl(pVideoInfo.src);
    }

    _videoInfo = pVideoInfo || null;
    _src = pSrc || null;

    if (!_videoInfo && !_src) {
      self.emit('mediaError', { message: 'Src not found' });
      return;
    }

    if (!_video) {
      createPlayer();
    }
    toggleEvents(true);

    _video.autoplay = true;

    if ('autoplay' in pOptions) {
      _video.autoplay = pOptions['autoplay'];
      delete pOptions['autoplay'];
    }

    if (_src && _src !== '') {
      _video.src = _src;
    } else {
      _video.src = pVideoInfo.src;
    }

    if (self.player.config['singleVideoInstance'] === true && _video.autoplay) {
      self.safeCall(function(){
        _video.load();
      });
    }

    _video.volume = self.get('volume') / 100;

    if (self.get('muted')) {
      _video.muted = true;
    }

    if ('startSeconds' in pOptions) {
      _startPosition = pOptions['startSeconds'];
    }
  };

  this.play = function () {
    if (_video.src) {
      playing = _video.play();
      self.safeCall(function(){
        playing = null;
        _started = true;
      }, function (error){
        playing = null;
        _started = false;
      });
      return playing;
    }
  };

  this.pause = function () {
    if (_video && !_paused) {
      this.safeCall(function(){
        _video.pause();
        _paused = true;
      }, function () {
        _paused = false;
      });
    }
  };

  this.safeCall = function(onSuccess, onError) {
    if (playing && playing.then) {
      playing.then(onSuccess, function (error) {
        if (onError) {
          onError(error);
        }
      });
    } else {
      onSuccess();
    }
  };

  this.stop = function () {
    if (_video) {
      _startPosition = 0;
      _video.src = '';
      if (self.player.config['singleVideoInstance'] === true) {
        _video.style.display = 'none';
        //if(this.namespace == this.DEFAULT_NAMESPACE) return; MHP-369
      } else {
        self.container.removeChild(_video);
      }

    }

    this.dispose();
  };

  this.togglePlayPause = function () {
    if (_video) {
      self.get('state') === 1 ? self.pause() : self.play();
    }
  };

  this.seekTo = function (seconds) {
    if (!_video) {
      return;
    }
    if (typeof seconds !== 'number' || Number.isNaN(seconds)) {
      self.log('seekTo: argument "seconds" has invalid value:', seconds);
      return;
    }
    setState(5);
    var timeToSeek = Math.min(Math.max(0, seconds), Math.min(self.get('duration') - 10, seconds));
    _video.currentTime = timeToSeek;
    self.set('position', timeToSeek);
    if (self.player.config.deviceOS === 'panasonic' && _startPosition) {
      _startPosition = 0;
    }
  };

  this.setVolume = function (pVolume) {
    if (pVolume > 100) {
      pVolume = 100;
    } else if (pVolume < 0) {
      pVolume = 0;
    }
    if (_video) {
      _video.volume = pVolume / 100;
    }
    self.set('volume', pVolume);
  };

  this.mute = function() {
    if (self.get('muted')) {
      return;
    }
    self.set('muted', true);
    _video.muted = true;
  };

  this.unMute = function() {
    if (!self.get('muted')) {
      return;
    }
    self.set('muted', false);
    _video.muted = false;
  };

  this.setQuality = function(bitrate) {
    _needToDisableSubtitles = true;
    this.emit('qualityNeedChange', bitrate);
  };

  this.setAudiotrack = function(id) {
    _needToDisableSubtitles = true;
    this.emit('audioTackNeedChange', id); // audioTackNeedChange -> audioTrackNeedChange
  };

  this.getPlayableElement = function () {
    return _video;
  };

  var createPlayer = function () {
    if (self.player.config['singleVideoInstance'] === true) {
      _video = self.player.get(self.namespace + 'video');
    }

    if (!_video) {
      _video = document.createElement('video');
      self.container.appendChild(_video);
    }
    window.safariVideo = _video;
    _video.className = self.namespace + 'video';
    _video.style.width = "100%";
    _video.style.height = "100%";
    _video.style.display = 'inline-block';

    if (pluginBuffering) {
      pluginBuffering.setVideo(_video);
    }
  };

  var setState = function (pNewState) {
    self.set('state', pNewState);
    self.emit('stateChange', pNewState);
  };

  var toggleEvents = function (pOn) {

    if (pOn) {
      if (_video) {
        _video.addEventListener("loadstart", onVideoLoadStart, false);
        _video.addEventListener("canplay", onVideoCanPlay, false);
        _video.addEventListener("pause", onVideoPause, false);
        _video.addEventListener("playing", onVideoPlaying, false);
        _video.addEventListener("seeked", onVideoSeeked, false);
        _video.addEventListener("seeking", onVideoSeeking, false);
        _video.addEventListener("volumechange", onVideoVolumeChange, false);
        _video.addEventListener("durationchange", onVideoDurationChange, false);
        _video.addEventListener("ended", onVideoEnded, false);
        _video.addEventListener("error", onVideoError, false);
        _video.addEventListener("waiting", onVideoWaiting);
      }

      if (self.player && self.player.on) {
        self.player.on("player:timeUpdate", onTimeUpdate);
      }

    } else {
      if (_video) {
        _video.removeEventListener("loadstart", onVideoLoadStart, false);
        _video.removeEventListener("canplay", onVideoCanPlay, false);
        _video.removeEventListener("pause", onVideoPause, false);
        _video.removeEventListener("playing", onVideoPlaying, false);
        _video.removeEventListener("seeked", onVideoSeeked, false);
        _video.removeEventListener("seeking", onVideoSeeking, false);
        _video.removeEventListener("volumechange", onVideoVolumeChange, false);
        _video.removeEventListener("durationchange", onVideoDurationChange, false);
        _video.removeEventListener("ended", onVideoEnded, false);
        _video.removeEventListener("error", onVideoError, false);
        _video.removeEventListener("waiting", onVideoWaiting);
      }

      if (self.player && self.player.off) {
        self.player.off("player:timeUpdate", onTimeUpdate);
      }
    }
  };

  var onVideoError = function () {
    setState(5);

    var errorType, errorCode, errorMessage;
    errorType = AddonError.errorTypes.NETWORK_ERROR;
    errorCode = AddonError.errorCodes[errorType].MEDIA_FILE_LOADING_ERROR;
    errorMessage = AddonError.errorMessages[errorCode] + _src;
    new AddonError(self.player, errorType, errorCode, errorMessage, true);

    self.emit("mediaError", { this: this });
  };

  var onVideoLoadStart = function () {
    setState(3);
  };

  var onVideoCanPlay = function () {
    if (_safariAfterSeekedTimeoutId) {
      clearTimeout(_safariAfterSeekedTimeoutId);
      _safariAfterSeekedTimeoutId = null;
    }

    if (!_started) {
      self.emit("mediaCanPlay");
    }

    if (_isBuffering) {
      _isBuffering = false;
      self.emit('buffering', { isBuffering: false, timestamp: new Date().getTime(), isSeeking: _video.seeking });
    }

    if (_startPosition > 0) {
      self.seekTo(_startPosition);
      if (_video && Math.abs(_video.currentTime - _startPosition) <= 10) {
        _startPosition = 0;
      }

      if (_startPosition > _video.duration && _video.duration !== 0) {
        _startPosition = 0;
      }
    } else {
      if (_isSafari && !_started) {
        _video.currentTime = 0.1;
      }

      if (_isSafari && !_safariAfterSeekedTimeoutId && _video && _video.autoplay) {
        if (_safariPlayRetryCount > 3) return;
        _safariPlayRetryCount ++;
        _safariAfterSeekedTimeoutId = setTimeout(function () {
          if (!_video) onVideoCanPlay();
          if (self.get('state') === 1 && _video.paused && !_isBuffering) {
            self.pause();
            _video.src = _src;
            self.play();
          }
        }, 3000);
      }
    }

  };

  var onVideoPause = function () {
    if (_paused) {
      setState(2);
    } else if (_video.paused) {
      setState(5);
    }

  };

  var onVideoPlaying = function () {
    if (_needToDisableSubtitles) {
      _needToDisableSubtitles = false;
      var tracks = _video.textTracks;
      if (tracks && tracks.length > 0) {
        for (var i = 0, l = tracks.length; i < l; ++i) {
          if (tracks[i].kind === 'subtitles') {
            tracks[i].mode = 'disabled';
          }
        }
      }
    }

    if (!_started) {
      var autoPlay = true;
      var vendorOptions = self.player.get('vendorOptions');
      if (vendorOptions && vendorOptions.autoplay !== undefined && vendorOptions.autoplay !== null) {
        autoPlay = vendorOptions.autoplay;
      }
      if (autoPlay === false) {
        setState(2);
        self.pause();
        _started = true;
        return;
      }
    }

    var dismissSeekToLiveAfterPause = self.player.get('vendor:dismissSeekToLiveAfterPause');
    if (_paused && dismissSeekToLiveAfterPause !== true) {
      var videoInfo = self.player.get('videoInfo');
      var extension = self.player.utils.getExtension(_video.src);
      if (videoInfo && (videoInfo.content_type === 'live' || videoInfo.content_type.indexOf('tv_linear') !== -1) && extension === 'm3u8' && _isSafari) {
        //this shit just need to make 'seek' into live
        _video.src = _video.src;

      }
    }

    _started = true;
    _paused = false;
    setState(1);
  };

  var onVideoSeeked = function () {
    if (_seekState) {
      setState(_seekState);
      _seekState = null;
    }
    self.emit("mediaSeekEnd");

    if (_isSafari) {
      if (_safariAfterSeekedTimeoutId) {
        clearTimeout(_safariAfterSeekedTimeoutId);
      }
      if (_safariStalledTimeoutId) {
        clearTimeout(_safariStalledTimeoutId);
      }
      if (!_paused) {
        _safariAfterSeekedTimeoutId = setTimeout(function () {
          self.play();
          onVideoCanPlay();
          onVideoPlaying();
          _safariAfterSeekedTimeoutId = null;
        }, 500);

        _safariStalledPosition = _video.currentTime;
        _safariStalledTimeoutId = setTimeout(function() {
          if (Math.abs(_safariStalledPosition - _video.currentTime) < 1) {
            _video.currentTime = _safariStalledPosition + 1;
          }
          _safariStalledTimeoutId = null;
        }, 3000);
      }
    }

    if (_isIos) {
      setTimeout(function() {
        if (self.get('state') !== -1 && !_video.paused && !_video.seeking && !_video.end) {
          onVideoPlaying();
        }
      }, 500);
    }
  };

  var onVideoSeeking = function () {
    if (!_seekState) {
      _seekState = _video.paused ? 2 : 1;
    }
    self.emit("mediaSeekStart");
    setState(4);
  };

  var onVideoVolumeChange = function () {
    self.set('volume', _video.volume * 100);
    self.set('muted', _video.muted);
  };

  var onVideoDurationChange = function () {
    self.set('duration', _video.duration);
  };

  var onVideoWaiting = function () {
    var bufferTime = getBufferTime();
    if (!_paused && bufferTime <= 1) {
      _isBuffering = true;
      self.emit('buffering', { isBuffering: true, timestamp: new Date().getTime(), isSeeking: _video.seeking });
      setState(3);
    }
  };

  var onTimeUpdate = function () {
    var position = self.get('position');
    var duration = self.get('duration');

    if (_isBuffering === false && _paused === false && _started === false) { // if trailer passes in state waiting(buffered)
      self.play();
    }

    if (_video.currentTime !== position) {
      self.set('position', _video.currentTime);
    }

    if (duration > 0 && duration - position < 1 && !_beforeCompleteFired) {
      _beforeCompleteFired = true;
      self.emit("mediaBeforeComplete");
    }

    for (var i = 0; i < _video.buffered.length; i++) {
      try {
        if (_video.buffered.start(i) <= position && _video.buffered.end(i) > position) {
          self.set('loadedFraction', _video.buffered.end(i) / duration);
          break;
        }
      } catch (error) {}
    }

    if (_video.duration > 0 && _video.currentTime > 0 && Math.abs(_video.duration - _video.currentTime) <= 0.01) {
      onVideoEnded();
    }
  };

  var onVideoEnded = function () {
    setState(0);
    toggleEvents(false);
    _started = false;
  };

  var removeM3U8FromBlobUrl = function (url) {
    if (url && url.indexOf('blob:') !== -1 && url.indexOf('.m3u8') !== -1) {
      url = url.substring(0, url.indexOf('.m3u8'));
    }
    return url;
  };

  var getBufferTime = function() {
    var result = -1;
    var video = self.player.getPlayableElement();
    if (video && video.buffered && video.buffered.length > 0) {
      var i = video.buffered.length;
      var pos = self.player.get('position');
      while (i--) {
        if (video.buffered.start(i) <= pos && video.buffered.end(i) >= pos) {
          result = video.buffered.end(i) - pos;
        }
      }
    }
    return result;
  };

  self.log('MggpVendorHtml5:Created!');
}

MggpVendorHtml5.prototype = Object.create(MggpVendor.prototype);
MggpVendorHtml5.prototype.constructor = MggpVendorHtml5;

MggpVendorHtml5.mimeTypes = [ "mp4", "webm", "m3u8" ];
MggpVendorHtml5.priority = 0;

MggpVendorHtml5.canPlay = function (pType, pConfig, pOptions) {
  var result = false;
  var isDrm = pOptions && 'isDrm' in pOptions ? pOptions.isDrm : pConfig.drm;
  if (!isDrm && pConfig.hasOwnProperty('m3u8NativSupported') && pConfig['m3u8NativSupported'] === true) {
    result = true;
  } else if (pType === 'm3u8' && ('MediaSource' in window || 'WebKitMediaSource' in window)) {
    if (isDrm) {
      result = false;
    } else {
      var source = window.MediaSource || window.WebKitMediaSource;
      if (source) {
        result = source.isTypeSupported('application/x-mpegurl');
      }
    }
  }
  if (pType !== 'm3u8') {
    result = true;
  }
  return result;
};
